<style scoped>
.line3 {
    text-decoration: underline;
    cursor: pointer;
    color: #4fa1a4;
}
.line1{
    font-weight: bold;
}
.secondStep img{
    width:170px;
}
/deep/ .el-dialog__body {
    padding-top: 0;
}
/deep/ .el-dialog__body {
    padding-top: 0;
}
/deep/ .el-dialog__header{
    text-align: left;
    padding:15px 20px 10px;
}
/deep/ .el-dialog__title{
    font-size: 16px;
}
</style>
<template>
    <el-dialog title="批量调整任务量" v-loading.fullscreen.lock="fullscreenLoading" :visible.sync="showImport" width="500px" class="importClass">
        <div class="secondStep">
            <img v-if="importResult.error==0" src="../../../assets/icon/import_success.png" alt="" srcset="">
            <img v-else src="../../../assets/icon/import_error.png" alt="" srcset="">
            <p class="line1" v-if="importResult.error == '0'">数据导入完成，请核对！</p>
            <p class="line1" v-else>数据导入完成，请核对！</p>
            <p class="line2">
                共需导入数据 <span style="color:#4fa1a4"> {{ importResult.total }} </span> 条，导入成功 <span style="color:#4fa1a4">{{ importResult.ok }} </span> 条
                <span v-if="importResult.error > 0">，失败<span :style="importResult.error>0?'color:red':''"> {{ importResult.error }} </span> 条。</span>
            </p>
            <p class="line3" @click="downFailData" v-if="importResult.error > 0">下载导入失败数据</p>
        </div>
    </el-dialog>
</template>
<script>
export default {
    props: {
        importResult: {
            type: Object,
            default: {},
        },

    },
    watch: {
    },
    data() {
        return {
            showImport: false,
            fullscreenLoading:false
        };
    },
    created() {

    },
    methods: {
        open() {
            this.showImport = true;
        },
        downFailData() {
            this.fullscreenLoading = true;
            this.api.postJsonD(`/${serverConfig.msSalesPerformService}/task/batch-update-task/export-error-data?importKey=${this.importResult.importKey}`)
                .then(res => {
                    this.fullscreenLoading = false;
                    let blob = new Blob([res.data], { type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet" });
                    let fileName = 'csbr_report_error' + this.$moment(new Date()).format('YYYYMMDD');
                    let objectUrl = URL.createObjectURL(blob);
                    const link = document.createElement('a')
                    link.download = fileName;
                    link.href = objectUrl;
                    link.click();

                });
        }
    },

};
</script>